<template>
  <div class="wrapper">
    <div id="map" class="container" @click="addNewPost($event)">
      <div id="post" :style="{ top: post.y + '%', left: post.x + '%'}">
      </div>
    </div>
    <div id="coordinates">
      <div >Y: {{ post.y }}</div>
      <div>X: {{ post.x }}</div>
    </div>
  </div>
</template>

<style lang="scss">
  .wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .container {
    border: #2AFE8B 10px solid;
    padding: 60px;
    width: 600px;
    height: 600px;
    position: relative;
  }

  #map {
    background-image: url('./../assets/outlinemap_treearrow.svg');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  #post {
    position: absolute;
    transform: translate(calc(-50% - 10px), calc(-50% - 10px));
    width: 20px;
    height: 20px;
    background-color: green;
    border-radius: 50%;
    cursor: pointer;

    &:hover .pop-up {
      background-color: green;
      display: block;
    }
  }

  #coordinates {
    display: flex;
    margin: 20px;
    background-color: orange;
    padding: 20px;
    color: white;

    div {
      margin: 10px 20px;
      font-size: 20px;
    }
  }

</style>

<script>
  export default {
    name: 'Home',
    data: function () {
      return {
        post: {
          x: 50,
          y: 50,
        }
      }
    },
    methods: {
      getCursorPosition(event) {
        let mapOffset = this.getOffsetContainer()

        let newXValue = this.calculateAxisPercentage(event.pageX - mapOffset.offLeft)
        let newYValue = this.calculateAxisPercentage(event.pageY - mapOffset.offTop)

        return {
          x: newXValue,
          y: newYValue,
        };
      },
      calculateAxisPercentage(axis) {
        return Math.round(((axis / 720) * 100));
      },
      getOffsetContainer() {
        let map = document.getElementById("map")

        return {
          offLeft: map.offsetLeft,
          offTop: map.offsetTop,
        }
      },
      addNewPost($event) {
        this.post = this.getCursorPosition($event);
      },
    }
  }
</script>
